import Config from 'conf';

export default socketMiddleware => {
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);
    return {
        updateConsoProd: function(fheCenter_mac, type, product_modules) {
            return new Promise((resolve, reject) => {
                let configureConsoProdFeedback = args => {
                    if (fheCenter_mac === args.fheCenter_mac && type === args.type) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        socketMiddleware.off('configureConsoProdFeedback', configureConsoProdFeedback);
                        if (args.res === 'success') return resolve(args);
                        return reject(new Error(args.error_msg));
                    }
                };
                socketOn('configureConsoProdFeedback', configureConsoProdFeedback);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('configureConsoProdFeedback', configureConsoProdFeedback);
                    reject(new Error('timeout'));
                }, Config.timeout_socket_order);

                socketEmit('configureConsoProd', { fheCenter_mac, type, product_modules });
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/genericEnv/eventsSocket/Home/index.js